import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import {
  Field,
  reduxForm,
  formValueSelector,
  change,
  getFormValues
} from "redux-form";
import { TextField } from "redux-form-material-ui";
// import { actionLoading } from "../../actions/AppActions";
import { actionLogin } from "../../actions/AuthActions";
// import {
//   actionSetCompleteRegistration,
//   actionLoginGoogle,
//   actionLoginFacebook
// } from "../../actions/LoginActions";
import {Button, Paper, Typography} from '@material-ui/core'
import SvgIcon from "@material-ui/core/SvgIcon";
import Username from "@material-ui/icons/Person";
import Password from "@material-ui/icons/VpnKey";
import { required, validateEmail, password } from "../../common/Validations";
import logo from "../../common/assets/logo.png";
import { withTheme } from "@material-ui/core/styles"

import {
  INDEX_ROUTE,
  // PASSWORD_RECOVERY,
  LOGIN_ROUTE,
  //ADD_USER_ROUTE
} from "../../config/RoutesConstants";
import { Grid, Row, Col } from "react-bootstrap";
import IconPicker from "../../components/IconPicker/IconPicker"
import Util, {
  ERROR,
  SUCCESS,
  WARNING,
  handleSubmitFail
} from "../../common/Util";
let _handleSubmitFail;

const FacebookIcon = props => (
  <SvgIcon {...props}>
    <path d="M1376 128q119 0 203.5 84.5t84.5 203.5v960q0 119-84.5 203.5t-203.5 84.5h-188v-595h199l30-232h-229v-148q0-56 23.5-84t91.5-28l122-1v-207q-63-9-178-9-136 0-217.5 80t-81.5 226v171h-200v232h200v595h-532q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960z" />
  </SvgIcon>
);

const GoogleIcon = props => (
  <SvgIcon {...props}>
    <path d="M1045 905q0-26-6-64h-362v132h217q-3 24-16.5 50t-37.5 53-66.5 44.5-96.5 17.5q-99 0-169-71t-70-171 70-171 169-71q92 0 153 59l104-101q-108-100-257-100-160 0-272 112.5t-112 271.5 112 271.5 272 112.5q165 0 266.5-105t101.5-270zm345 46h109v-110h-109v-110h-110v110h-110v110h110v110h110v-110zm274-535v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z" />
  </SvgIcon>
);

const styles = {
  link: {
    color: "#1958b7"
  }
};

class loginMain extends Component {
  constructor(props) {
    super(props);
    this.state = {
      state: "estado",
      error: ""
    };
    _handleSubmitFail = handleSubmitFail.bind(this);
    this.loginCallback = this.loginCallback.bind(this);
    // this.facebookPopup = this.facebookPopup.bind(this);
    // this.googlePopup = this.googlePopup.bind(this);
    //this.onPressRegisterUser = this.onPressRegisterUser.bind(this);
  }

  componentWillMount() {
    if (this.props.login) {
      this.props.history.replace(INDEX_ROUTE);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.login) {
      this.props.history.replace(INDEX_ROUTE);
    }
  }

  onSubmit(formValues) {
    const values = JSON.parse(JSON.stringify(formValues));
    this.props.actionLogin(values, 
      ()=>{
        this.props.history.push(INDEX_ROUTE)
      },
      (e)=>{
        if(!(e&&e.status&&e.status==401))
          Util.showNoty(ERROR,e.message)
      }
    );
  }

  loginCallback(value) {
    this.setState({ loading: false });
    if (value) {
      this.props.reset();
      this.setState({ error: value });
    } else {
      this.props.history.push(INDEX_ROUTE);
    }
  }

  // onRecoveryPassword = e => {
  //   e.preventDefault();
  //   this.props.history.push(PASSWORD_RECOVERY);
  // };

  // onPressRegisterUser() {
  //   this.props.history.push(ADD_USER_ROUTE);
  // }

  // googlePopup() {
  //   //this.props.actionLoading(true);
  //   //this.props.actionSetCompleteRegistration(false);
  //   this.props.actionLoginGoogle();
  // }

  // facebookPopup() {
  //   //this.props.actionLoading(true);
  //   //this.props.actionSetCompleteRegistration(false);
  //   this.props.actionLoginFacebook();
  // }

  

  render() {
    const { handleSubmit, theme } = this.props;
    return (
      <div className="screen-login">
        <Col
          style={{
            flex: 1
          }}
          className="bg-login columns-column-between imagen-fondo-login"
        >
          <div>
           <form style={theme.paper.form}>
              <Col
                xs={12}
                sm={12}
                md={8}
                mdOffset={2}
                className="container-login top100"
              >
                <Paper className="paper-login">
        <Typography style={theme.paper.title} variant="h2">Iniciar Sesión {process.env.REACT_APP_APP_DISPLAY_NAME}</Typography>
                 <div className="fields-login">
                    <Username style={{ marginRight: 10, color: "#ccc" }} />
                    <Field
                      component={TextField}
                      className="textField"
                      name="email"
                      type="text"
                      fullWidth
                      hintText="someone@example.com"
                      label="E-mail"
                      floatingLabelFixed
                      validate={[required, validateEmail]}
                    />
                  </div>
                  <div className="fields-login">
                    <Password style={{ marginRight: 10, color: "#ccc" }} />
                    <Field
                      component={TextField}
                      className="textField"
                      name="password"
                      type="password"
                      fullWidth
                      label="Contraseña"
                      floatingLabelFixed
                      validate={[required, password]}
                    />
                  </div>
                  {this.state.error !== "" ? (
                    <div className="text-center top20" style={{ color: "red" }}>
                      {this.state.error}
                    </div>
                  ) : null}
                  {/* <div className="rows-column-simple align-bottom position-forgotpass right20 bottom10">
                    <a
                      href="#"
                      style={styles.link}
                      onClick={this.onRecoveryPassword}
                    >
                      Olvidé mi contraseña
                    </a>
                  </div> */}
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit(this.onSubmit.bind(this))}
                    fullWidth
                    className="top30"
                    style={{ height: 40, marginTop:10 }}
                  >
                    Ingresar
                  </Button>
                 {/* <Button
                    label="Registrarse"
                    onClick={this.onPressRegisterUser.bind(this)}
                    fullWidth
                    style={{ height: 40 }}
                  /> */}
                </Paper>
              </Col>
              <br />
              <br />
              <br />
              {/* <Col
                xs={12}
                sm={12}
                md={8}
                mdOffset={2}
                className="container-login"
              >
                <div className="columns-row-between social-login">
                  <Button
                    variant="contained"
                    primary={false}
                    disabled
                    label="Login con Facebook"
                    labelPosition="before"
                    onClick={this.facebookPopup}
                    className="top20"
                    startIcon={
                      <FacebookIcon
                        viewBox="0 0 1792 1792"
                        color={"#005FB2"}
                        hoverColor={"#000"}
                      />
                    }
                  />
                  <Button
                    variant="contained"
                    primary={false}
                    disabled
                    label="Login con Google"
                    labelPosition="before"
                    onClick={this.googlePopup}
                    className="top20"
                    startIcon={
                      <GoogleIcon
                        viewBox="0 0 1792 1792"
                        color={"#ff0000"}
                        hoverColor={"#000"}
                      />
                    }
                  />
                </div>
              </Col> */}
            </form> 
          </div>
        </Col>
      </div>  
    );
  }
}

function mapStateToProps(store) {
  return {
    login: store.auth.login,
    rol: store.app.rol,
    username: store.app.username,
    active: store.app.activeFilters,
    loading: store.app.loading
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionLogin,
      // actionLoading
    },
    dispatch
  );
}

export default reduxForm({
  form: "loginMain",
  onSubmitFail: errors => _handleSubmitFail(errors)
})(
  withRouter(
    withTheme(
      connect(
        mapStateToProps,
        mapDispatchToProps
      )(loginMain)
    )
  )
);



// WEBPACK FOOTER //
// ./src/screens/login/LoginMain.js